import { DatagridPage } from './pages/DatagridPage';
import { DatasynthPage } from './pages/DatasynthPage';

// Tiny path router. Cloudflare Pages serves index.html for every path
// (see public/_redirects), so cross-product links are plain <a href> that
// trigger a normal load and land here. In-page #anchors are unaffected.
export default function App() {
  const path = window.location.pathname.replace(/\/+$/, '');
  if (path === '/datasynth') return <DatasynthPage />;
  return <DatagridPage />;
}
